export default "__VITE_ASSET__Q$CMTAdm__"